import type { ReactiveController, ReactiveControllerHost } from 'lit'
import { getElementsAround, setInertAttributes } from '../../common/inert.js'

export class FocusTrapController implements ReactiveController {
  private inertElements: Element[] = []

  constructor(private host: ReactiveControllerHost & HTMLElement) {
    host.addController(this)
  }

  hostDisconnected() {
    this.release()
  }

  trap() {
    // Toasts are non-modal, always-accessible feedback: they render in the top
    // layer above modals and must stay interactive, so never make them inert.
    const elements = getElementsAround(this.host).filter(element => element.localName !== 'nord-toast-group')

    setInertAttributes(elements, true)
    this.inertElements = elements
  }

  release() {
    setInertAttributes(this.inertElements, false)
    this.inertElements = []
  }
}
